export default {"src":"/_next/static/media/Vitiligo.ad7cb5c1.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};